<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 16 16"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" :fill="background" r="8"/>
    <path d="M9 2L5 9H8L7 14L11 7H8L9 2Z" :fill="fill"/>
  </svg>

</template>

<script>
export default {
  name: 'Flash',
  props: {
    width: {
      type: String,
      required: false,
      default: '16'
    },
    height: {
      type: String,
      required: false,
      default: '16'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    background: {
      type: String,
      required: false,
      default: '#FFDF00'
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};
</script>
